var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 pt-5 mt-4 d-flex justify-content-center"},[_c('div',{staticClass:"white-arrow pt-4 text-center col-1 d-none d-sm-block"},[_c('a',{attrs:{"href":_vm.urlRef}},[_c('i',{staticClass:"arrow"})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f04a6634","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/Arrow.vue
// module id = 57
// module chunks = 0